import { theme } from '../../../theme';
import { OUTCOME_CONFIG } from '../../assessment-history/types/assessmentHistory.types';
import type { OutcomeCount } from '../types/dashboard.types';

type OutcomeBreakdownProps = {
  outcomeCounts: OutcomeCount[];
  total: number;
};

export const OutcomeBreakdown = ({ outcomeCounts, total }: OutcomeBreakdownProps) => {
  return (
    <div className={theme.card.padded}>
      <h3 className={`text-sm font-semibold ${theme.text.heading} mb-4`}>Assessment Outcomes</h3>
      <div className="space-y-3">
        {outcomeCounts.map(({ outcome, count }) => {
          const config = OUTCOME_CONFIG[outcome];
          const pct = total > 0 ? Math.round((count / total) * 100) : 0;
          return (
            <div key={outcome}>
              <div className="flex items-center justify-between mb-1.5">
                <span className={`text-sm font-medium ${config.colorClass}`}>{config.label}</span>
                <span className={`text-sm font-bold ${theme.text.heading}`}>
                  {count} <span className={`text-xs font-normal ${theme.text.muted}`}>({pct}%)</span>
                </span>
              </div>
              <div className={`h-2 rounded-full dark:bg-white/[0.06] bg-gray-100 overflow-hidden`}>
                <div
                  className={`h-full rounded-full transition-all duration-700 ease-out ${config.bgClass.includes('red') ? 'bg-sy-red' : config.bgClass.includes('amber') ? 'bg-amber-500' : config.bgClass.includes('yellow') ? 'bg-yellow-500' : 'bg-sy-green'}`}
                  style={{ width: `${pct}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
